import { type LayoutProps } from "@root/clientFrontend/features/scout/components/WorkSelector/type";
import { ToggleButton } from "@root/clientFrontend/features/scout/components/WorkSelector/uiParts/ToggleButton";
import { Label } from "@root/shared/components/Label";
import * as styles from "./styles.css";

export const PcLayout = ({
  isRequired,
  totalWorksCount,
  toggleButtonText,
  onToggleButtonClick,
  selectableWorksCount,
  children,
  toggleButtonClassName,
  hasBorder,
  isDescriptionVisible,
  recommendText,
}: LayoutProps) => (
  <>
    <p className={styles.title} id="js-work-selector">
      求人{!isRequired && <>を選択</>}
      {isRequired ? (
        <Label theme="deepPink">必須</Label>
      ) : (
        <Label theme="lightGray" className={styles.label}>
          任意
        </Label>
      )}
      {isDescriptionVisible && (
        <span className={styles.description}>
          選択した求人で、スカウトを送信できる求職者のみが検索結果に表示されます。
        </span>
      )}
    </p>
    <div className={hasBorder ? styles.containerWithBorder : undefined}>
      <div className={styles.buttonAndCountOuter}>
        <ToggleButton
          text={toggleButtonText}
          onClick={onToggleButtonClick}
          className={toggleButtonClassName}
        />
        <p className={styles.countOuter} aria-label="求人数">
          <span className={styles.currentCount}>{selectableWorksCount}</span>/{totalWorksCount}
          件表示中
          {recommendText && <span className={styles.recommendText}>{recommendText}</span>}
        </p>
      </div>
      {children}
    </div>
  </>
);
